// Mirrors REQUEST_STATUSES in server/src/api/request/request.constants.js.
// A status the server can store and this map does not carry renders as a raw
// enum value in a badge, so the two move together.
export const REQUEST_STATUS_LABELS = Object.freeze({
    open: 'Open',
    accepted: 'Accepted',
    declined: 'Declined',
    withdrawn: 'Withdrawn',
});

export const REQUEST_STATUS_VARIANTS = Object.freeze({
    open: 'warning',
    accepted: 'success',
    declined: 'secondary',
    withdrawn: 'dark',
});

// The statuses a request is still live in. The server refuses a message on
// anything else with REQUEST_CLOSED, so the message form and the party
// actions gate on this list rather than on `status === 'open'` alone.
export const REQUEST_OPEN_STATUSES = Object.freeze(['open', 'accepted']);

// Mirrors MESSAGE_MAX_LENGTH in
// server/src/api/request/request.constants.js. The server refuses a longer
// body with a 400 that discards what was typed, so the limit is enforced and
// counted in the form rather than discovered on the round trip.
export const MESSAGE_MAX_LENGTH = 2000;
